import { createSelector } from '@reduxjs/toolkit';

import { IProduct, IStore2, ITip, TipScreenTypes } from 'types';

const specificProductSelector = (state: IStore2) => state.specificProduct;

const tipSelector = (state: IStore2) => state.config.tips;

const getProductSelector = createSelector([specificProductSelector], (product): IProduct => {
  return {
    id: product.id,
    images: product.images,
    title: product.title,
    description: product.description,
    price: product.price,
    originalPrice: product.originalPrice || product.price,
    currencySymbol: product.currencySymbol,
    currencyCode: product.currencyCode,
    convertedFromPrice: product.convertedFromPrice,
    shippingInformation: product.shippingInformation,
    isDigital: product.isDigital,
    hasInstantCheckout: product.hasInstantCheckout,
    tariffNumber: product.tariffNumber,
    quantity: product.quantity || 0,
    category: product.category,
    labels: product.labels || [],
    isLiked: product.isLiked,
    totalLikes: product.totalLikes,
  };
});

const getTipSelector = createSelector([tipSelector], (tips): ITip | null => {
  return tips.find((tip) => tip.displayedRoutes.includes(TipScreenTypes.Product)) || null;
});

export const SpecificProductSelector = {
  getProductSelector,
  getTipSelector,
};
